import type { TFunction } from 'i18next'
import { z } from 'zod'

import { isFormattedTextLengthValid } from '../refinements/formatted-text.ts'

export const ExampleVideoUpdateFormModelSchema = (t: TFunction<'validation'>) =>
  z.object({
    title: z.string().refine((val) => val.length > 0, {
      message: t('example-video-form.title.errors.required'),
    }),
    description: z.string().superRefine((val, ctx) =>
      isFormattedTextLengthValid(t, t('example-video-form.description.label'), {
        min: 1,
      }).refinement(val, ctx)
    ),
  })
